<template>
  <div>
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">{{ $t('yhubReport.historyReport') }}</p>
        <el-table v-loading="loading1" :data="historyTotalData" border style="width: auto;" fit class="myTable">
          <el-table-column :label="$t('yhubReport.Date')" prop="date" align="center" />
          <el-table-column :label="$t('yhubReport.StartingTime')" prop="start" align="center" />
          <el-table-column :label="$t('yhubReport.EndTime')" prop="stop" align="center" />
          <el-table-column :label="$t('yhubReport.WorkingHours')" prop="workHours" align="center" />
          <!-- <el-table-column label="Km" prop="Km" align="center" /> -->
          <el-table-column :label="$t('yhubReport.InputHourmeter')" prop="HourmeterTime" align="center" />
        </el-table>
        <el-table v-loading="loading2" :data="historyReportData" border style="width: auto;margin-top: 20px;" fit class="myTable">
          <el-table-column :label="$t('allDeviceDetail.time')" prop="time" align="center" />
          <el-table-column :label="$t('basicinfo.Voltage')" prop="voltage" align="center" />
          <el-table-column :label="$t('warningPage.SOC')" prop="soc" align="center" />
          <el-table-column :label="$t('yhubReport.Hourmeter')" prop="HourMeter" align="center" />
          <el-table-column :label="$t('yhubReport.Ignition')" prop="Ignition" align="center" />
        </el-table>
      </el-col>
    </el-row>
    <!-- 列表模块————分页 -->
    <div style="background-color: white;width: 100%;padding: 10px 20px 20px;">
      <div class="pagination-container">
        <el-pagination
          v-if="pageshow"
          background
          current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { pageHourMeterEventStatisticsByDay, getHourMeterStatisticsByDay } from '@/api/yhub'
import { getDateAndHour, usedTime, howLongAgo, getDateAndWeek } from '@/utils/updateTime.js'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
export default {
  components: {
  },
  props: {
    mcuId: {
      type: String,
      default: ''
    },
    startTime: {
      type: Number,
      default: 0
    },
    endTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      historyReportData: [],
      historyTotalData: [],
      loading1: true,
      loading2: true
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
    },
    mcuId(newValue, oldValue) {
      this.queryList()
    },
    startTime(newValue, oldValue) {
      this.queryList()
    },
    endTime(newValue, oldValue) {
      this.queryList()
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    queryList() {
      var param1 = {
        mcuId: this.mcuId,
        startTime: this.startTime,
        endTime: this.endTime,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
        // endTime: 1607412759017,
        // mcuId: '003800455950501620333658',
        // startTime: 0
      }
      this.loading2 = true
      pageHourMeterEventStatisticsByDay(param1).then(res => {
        this.loading2 = false
        if (res.resultCode != 1001 || !res.resultModel) return
        this.listQuery.pageInfo.total = res.resultModel.total // 分页
        this.historyReportData = []
        res.resultModel.list.forEach(v => {
          var jsonData = JSON.parse(v.jsonData) || {}
          this.historyReportData.push({
            time: getDateAndHour(v.eventTime, 'noSecond'),
            voltage: Math.round(jsonData.voltageRaw / 100) + ' V',
            soc: Math.round(jsonData.soc / 100) + ' %',
            HourMeter: v.hourMeterStatus == 1 ? i18n.t('location.enable') : i18n.t('location.disable'), // 开始 关闭
            Ignition: v.ignitionStatus == 1 ? i18n.t('location.enable') : i18n.t('location.disable')
          })
        })
      })
      this.loading1 = true
      getHourMeterStatisticsByDay(param1).then(res => {
        this.loading1 = false
        if (res.resultCode != 1001 || !res.resultModel) return
        this.historyTotalData = []
        res.resultModel.forEach(v => {
          this.historyTotalData.push({
            date: getDateAndHour(v.startTime, 'noTime'),
            start: getDateAndHour(v.startTime, 'HourAndTime'),
            stop: getDateAndHour(v.endTime, 'HourAndTime'),
            workHours: usedTime(v.workTime),
            HourmeterTime: usedTime(v.hourMeterTime)
          })
        })
      })
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>

<style lang="scss" scoped>
*{
  // padding:0;
  margin:0;
  font-family: '微软雅黑';
}

</style>
